import { HelpHintWindow } from "@/components/ui/HintWindow";
import { PanelGrid } from "@/components/ui/Panel";
import { useLanguage } from "@/context/LanguageContext";
import {
  BanknotesIcon,
  CheckCircleIcon,
  DocumentArrowUpIcon,
  HomeModernIcon,
} from "@heroicons/react/24/outline";

import { PortfolioPageInsightItem } from "@/components/portfolio/portfolio-page/PortfolioPageInsightItem";

type TransactionHintWindowProps = {
  isOpen: boolean;
  onToggle: () => void;
};

export function TransactionHintWindow({
  isOpen,
  onToggle,
}: TransactionHintWindowProps) {
  const { language } = useLanguage();
  const copy = {
    cs: {
      help: "Nápověda",
      title: "Portfolio nemovitosti",
      description:
        "Hodnota, výnosy a transakce vybrané nemovitosti na jednom místě.",
      hideHelp: "Skrýt nápovědu",
      valueTitle: "Hodnota nemovitosti",
      valueText:
        "Sledujte odhadovanou hodnotu, pořizovací cenu a cenové zhodnocení nemovitosti.",
      cashFlowTitle: "Příjmy a výdaje",
      cashFlowText:
        "Procházejte měsíce a kontrolujte nájem, pravidelné výdaje i jednorázové transakce.",
      verificationTitle: "Ověření plateb",
      verificationText:
        "Potvrďte přijaté platby nebo pošlete nájemci připomínku.",
      importTitle: "Bankovní výpis",
      importText:
        "Importujte výpis pro automatické ověření a doplnění transakcí.",
    },
    en: {
      help: "Help",
      title: "Property portfolio",
      description:
        "The selected property's value, returns, and transactions in one place.",
      hideHelp: "Hide help",
      valueTitle: "Property value",
      valueText:
        "Track the estimated value, purchase price, and property appreciation.",
      cashFlowTitle: "Income and expenses",
      cashFlowText:
        "Browse individual months and review rent, recurring expenses, and one-time transactions.",
      verificationTitle: "Payment verification",
      verificationText:
        "Confirm received payments or send the tenant a reminder.",
      importTitle: "Bank statement",
      importText:
        "Import a statement to verify and add transactions automatically.",
    },
  }[language];

  if (!isOpen) return null;

  return (
    <HelpHintWindow
      eyebrow={copy.help}
      title={copy.title}
      description={copy.description}
      closeLabel={copy.hideHelp}
      onClose={onToggle}
    >
      <PanelGrid className="xl:grid-cols-4">
        <PortfolioPageInsightItem
          icon={HomeModernIcon}
          title={copy.valueTitle}
          text={copy.valueText}
        />
        <PortfolioPageInsightItem
          icon={BanknotesIcon}
          title={copy.cashFlowTitle}
          text={copy.cashFlowText}
        />
        <PortfolioPageInsightItem
          icon={CheckCircleIcon}
          title={copy.verificationTitle}
          text={copy.verificationText}
        />
        <PortfolioPageInsightItem
          icon={DocumentArrowUpIcon}
          title={copy.importTitle}
          text={copy.importText}
        />
      </PanelGrid>
    </HelpHintWindow>
  );
}
